module.exports = __webpack_public_path__ + "static/img/sh1.66b4da3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sh1.svg
// module id = 74+N
// module chunks = 1